//import simpleParallax from 'simple-parallax-js';
/*let actuCard = document.querySelectorAll('*[data-modal]');
let modalActu = document.querySelectorAll('.modal-actu');
let closeModal = document.querySelectorAll('.fa-times');
actuCard.forEach(function (el){
    el.addEventListener('click', function (){
            document.getElementById(el.getAttribute('data-modal')).classList.add('modal-actu-active');
    });
})
modalActu.forEach(function (el){
    // console.log(el.querySelector('.fa-times'));
    el.querySelector('.fa-times').addEventListener('click', function () {
        el.classList.remove('modal-actu-active');
    })
})*/

$('.linkinside').on('click',function(e){
    e.preventDefault();
    e.stopPropagation();
});
import simpleParallax from 'simple-parallax-js';
let nb_outils = 0;
let circle1 = document.getElementsByClassName('circle-1');
new simpleParallax(circle1,{
    delay: 2,
    orientation: 'left',
    overflow: true,
    scale:2,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.hero'
});

let circle2 = document.getElementsByClassName('circle-2');
new simpleParallax(circle2,{
    delay: 0.6,
    orientation: 'up',
    overflow: true,
    scale:3,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.hero'
});

let circle3 = document.getElementsByClassName('circle-3');
new simpleParallax(circle3,{
    delay: 1,
    orientation: 'down',
    overflow: true,
    scale:1.5,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.hero'
});

let circle4 = document.getElementsByClassName('circle-4');
new simpleParallax(circle4,{
    delay: 1,
    orientation: 'left',
    overflow: true,
    scale:1.5,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.hero'
});

let circle5 = document.getElementsByClassName('circle-5');
new simpleParallax(circle5,{
    delay: 1,
    orientation: 'up',
    overflow: true,
    scale:8,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.hero'
});


let circle_intro = document.getElementsByClassName('circle-intro');
new simpleParallax(circle_intro,{
    delay: 1,
    orientation: 'left',
    overflow: true,
    scale:2,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.hero'
});

// let
//icon_slider = document.getElementsByClassName('item_icon');
// new simpleParallax(icon_slider,{
//     delay: 2,
//     orientation: 'right',
//     overflow: true,
//     scale:1.8,
// 	transition: 'cubic-bezier(0,0,0,1)'
// });
let circle1_qui = document.getElementsByClassName('circle-qui-1');
new simpleParallax(circle1_qui,{
    delay: 2,
    orientation: 'down',
    overflow: true,
    scale:2,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.qui_falc'
});
let circle2_qui = document.getElementsByClassName('circle-qui-2');
new simpleParallax(circle2_qui,{
    delay: 1,
    orientation: 'down',
    overflow: true,
    scale:3,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.qui_falc'
});

// CIRCLES TRADUCTION
let circle1_traduc = document.getElementsByClassName('circle-traductions-1');
new simpleParallax(circle1_traduc,{
    delay: 2,
    orientation: 'down',
    overflow: true,
    scale:2,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.traduction_documents'
});

let circle2_traduc = document.getElementsByClassName('circle-traductions-2');
new simpleParallax(circle2_traduc,{
    delay: 0.6,
    orientation: 'up',
    overflow: true,
    scale:2,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.traduction_documents'
});

let circle3_traduc = document.getElementsByClassName('circle-traductions-3');
new simpleParallax(circle3_traduc,{
    delay: 1,
    orientation: 'up',
    overflow: true,
    scale:2,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.traduction_documents'
});

let circle4_traduc = document.getElementsByClassName('circle-traductions-4');
new simpleParallax(circle4_traduc,{
    delay: 3,
    orientation: 'up',
    overflow: true,
    scale:1.5,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.traduction_documents'
});

let circle5_traduc = document.getElementsByClassName('circle-traductions-5');
new simpleParallax(circle5_traduc,{
    delay: 1,
    orientation: 'down',
    overflow: true,
    scale:5,
	transition: 'cubic-bezier(0,0,0,1)',
    customWrapper: '.traduction_documents'
});


//
// special cursor button
// let
//h = document.querySelector(".cursor");

// h.onmousemove = function(e) {
//   /* 15 = background-size/2 */
//   h.style.setProperty(
//     "background-position",
//     e.clientX - 50 + "px " + (e.clientY - 50) + "px"
//   );
// };


// slider exemples
$(document).ready(function(){
    function getFOcus(){
        window.location = "";
    }

    //Hamburger
    $('#hamburger').on('click', function(e) {
        $(this).toggleClass('active');
        $('.site_header_main-navigation').toggleClass('open');
        $('.site_header_main-search').toggleClass('open');
    });
    $('.toggle-filters').on('click', function(e) {
        e.preventDefault();
        $('.filters-labels').toggleClass('open');
        if($('.filters-labels').hasClass('open')) {
            $(this).html('Cacher les filtres');
        } else {
            $(this).html('Afficher les filtres');
        }
    });

    //Close burger on link click
    $('.site_header_main-navigation ul li a').on('click', function (e) {
        // e.preventDefault();
        $('#hamburger').toggleClass('active');
        $('.site_header_main-navigation').toggleClass('open');
        $('.site_header_main-search').toggleClass('open');
    })


    //Scroll to
    $( "a.button_down,.site_header_main-navigation ul li a,a.logo,.skip-link,.menu-footer-container a" ).on('click',function( event ) {
            let offsetvalue = $(this).attr("data-offset");
            // event.preventDefault();
            $("html, body").animate({ scrollTop: $($(this).attr("href")).offset().top - offsetvalue}, 700);

            // alert(hash);



        $('.section_title').removeAttr("tabindex");
        // console.log('section'+ hash +' .section_title');
        setTimeout(function(){

            let hash = window.location.hash;
            // console.log(hash);
            $('section'+hash+' .section_title:first').attr("tabindex",-1).focus();
        }, 700);
    });
    // $( window ).on( 'hashchange', function( e ) {


    // } );

    // Sticky nav
    let stickyTop = $('.site_header_main').offset().top;

    $(window).on( 'scroll', function(){
        if ($(window).scrollTop() >= stickyTop) {
            $('.site_header_main').addClass('sticky');
        } else {
            $('.site_header_main').removeClass('sticky');
        }
    });


    /*window.onscroll = function() {onScroll()};

    function onScroll(event){
        let scrollPos = $(document).scrollTop();
        let menuitem = $('.site_header_main-navigation ul li a');

        menuitem.each(function () {

            let currLink = $(this);
            let offsetsection = $(this).attr("data-offset");
            let refElement = $(currLink.attr("href"));

            // console.log(refElement);

            if (refElement.position().top - offsetsection -1 <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
                menuitem.parent().removeClass("active");
                currLink.parent().addClass("active");
                console.log(currLink);
            }
            else{
                currLink.parent().removeClass("active");
            }
        });
    } */
    let menuScrollTimer = null;
    // Detect how far are we from the top of the page
    $(window).scroll(function (e) {
        // Avoid triggering the logic if the scroll event is triggerd from clicking one of the items
        if (menuScrollTimer === null) {
            let windowTop = $(this).scrollTop();
            
            $('.site_header_main-navigation ul li a').each(function (event) {
                if (windowTop >= $($(this).attr('href')).offset().top - 100) {
                    //
                    // $('.site_header_main-navigation ul li.active:not(:last-of-type)').removeClass('active');
                    $(this).parent().not('.contact').addClass('active').prev().removeClass('active');
                    
                }else{
                    $(this).parent().removeClass('active');
                }
            });

            //$('.site_header_main-navigation ul li.active').not(':last').removeClass('active');
        }
    });

    // Add active classes if visible in viewport
    $('.site_header_main-navigation ul li a').on('click',function(e){
        $('.site_header_main-navigation ul li a').parent().removeClass('active');
        $(this).parent().addClass('active');
    });



    // Search
    let searchOpen = false;
    $('.site_header_main-search-button').on('click',function(e){
        e.preventDefault();


        if(window.innerWidth < 1900 || (searchOpen && $('#s').val() != '')) {
            $('#search-form').submit();
        }

        if(window.innerWidth >= 1900) searchOpen = !searchOpen;
        $('#s').focus();
    });

    //
    // $('.next_step').on('click', function(e){
    //     e.preventDefault();
    //     $('.step').removeClass('active');
    //     $('.step').find('.fleche').show();
    //     $(this).parent().parent().parent().next().addClass('active').find('.fleche').hide();
    //     $(this).parent().parent().parent().find('.fleche').hide();
    // });

    // $('.traduction_documents-etapes-steps .step .number').on('click', function(e){
    //     e.preventDefault();
    //     $('.step').removeClass('active');
    //     $('.step').find('.fleche').show();
    //     $(this).parent().addClass('active');
    //     $(this).parent().find('.fleche').hide();
    //     $(this).parent().prev().find('.fleche').hide();
    // });
    // BG size filters
    function calculeReste(){
        let containerwidth = $('.container').width() + 30;
        let filterwidth = containerwidth / 3;
        let windowwidth = $(window).width();
        let restewidth = (windowwidth - containerwidth)/2;
        $('#outils .filtersbg').css({width : restewidth + filterwidth});

    }
    $(window).on( 'resize', calculeReste);
    calculeReste();

    let $window = $(window),
    $nav = $('.filters-container'),
    offsetnav = $('.site_header_main-navigation').height(),
    navTop = $nav.offset().top - offsetnav;

    $window.scroll(function() {
        $nav.toggleClass('sticky', $window.scrollTop() > navTop);
    });
    //Toggle filters
    $('.filters-labels-item').not('.filters-labels-item_all').on('click',function(){
        $('.filters-labels-item_all').find('input[type="checkbox"]').prop('checked', false);
        $(this).toggleClass('active');
        $('.outils_list-item').hide();

        nb_outils = 0;

        $('.filters-labels-item').not('.filters-labels-item_all').each(function(){
            if($(this).find('input[type="checkbox"]').is(':checked')){
                let filterName = $(this).data('filter');
                $('.outils_list-item.'+ filterName).show();
                nb_outils += $('.outils_list-item.'+ filterName).length;
            }
        });

        $('.nb-outils').html("<span>"+ nb_outils +" outil"+(nb_outils > 1 ? 's' : '')+"</span>");
    });
    $('.filters-labels-item_all').on('click',function(){
        // $('.filters-labels-item').removeClass('active');
        $('.filters-labels-item').not($('.filters-labels-item_all')).find('input[type="checkbox"]').prop('checked', false);
        $(this).find('input[type="checkbox"]').prop('checked', true);

        // $(this).toggleClass('active');
        $('.outils_list-item').show();
        nb_outils = $('.outils_list-item').length;
        $('.nb-outils').html("<span>"+ nb_outils +" outil"+(nb_outils > 1 ? 's' : '')+"</span>");
    });
    $('.filters-reinit').on('click',function(e){
        e.preventDefault();
        $('.filters-labels-item').not($('.filters-labels-item_all')).find('input[type="checkbox"]').prop('checked', false);
        $('.filters-labels-item_all').find('input[type="checkbox"]').prop('checked', true);

        $('.outils_list-item').show();
        nb_outils = $('.outils_list-item').length;
        $('.nb-outils').html("<span>"+ nb_outils +" outil"+(nb_outils > 1 ? 's' : '')+"</span>");
    });
    //modals
    // $('.showmodal').on('click',function(e){
    //     e.preventDefault();
    //     $('body').addClass('modals_open');
    //     let
    //    modalname = $(this).attr("href");
    //     $('.modals' + modalname).addClass('show');
    //     console.log(modalname);
    // });
    // $('.modals .modals_header-close').on('click',function(){
    //     $('.modals').removeClass('show');
    //     $('body').removeClass('modals_open');
    // });

});





/** File upload styles **/
